import { Controller } from '@hotwired/stimulus'
import WaveSurfer from 'wavesurfer.js'

let currentPlayer = null

const PLAY_ICON = `
  <svg width="20" height="20" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>
  </svg>
`

const PAUSE_ICON = `
  <svg width="20" height="20" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="black" d="M216,48V208a16,16,0,0,1-16,16H160a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h40A16,16,0,0,1,216,48ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Z"/>
  </svg>
`

export default class AudioPlayerController extends Controller {
  static targets = ['waveform', 'playButton', 'duration']

  static values = {
    url: String
  }

  connect() {
    this.totalDuration = 0

    this.player = WaveSurfer.create({
      container: this.waveformTarget,
      height: 36,
      barWidth: 3,
      barGap: 2,
      barRadius: 2,
      normalize: true,
      waveColor: '#9a7a9c',
      progressColor: '#f773c5',
      cursorWidth: 0
    })

    this.player.load(this.urlValue)

    this.player.on('ready', () => {
      this.totalDuration = this.player.getDuration()
      this.durationTarget.textContent = this.format(this.totalDuration)
    })

    this.player.on('timeupdate', (currentTime) => {
      this.durationTarget.textContent = `${this.format(currentTime)} / ${this.format(this.totalDuration)}`
    })

    this.player.on('finish', () => {
      this.playButtonTarget.innerHTML = PLAY_ICON
      this.durationTarget.textContent = `0:00 / ${this.format(this.totalDuration)}`
    })
  }

  toggle() {
    if (currentPlayer && currentPlayer !== this) {
      currentPlayer.player.pause()
      currentPlayer.playButtonTarget.innerHTML = PLAY_ICON
      currentPlayer.durationTarget.textContent = `0:00 / ${currentPlayer.format(currentPlayer.totalDuration)}`
    }

    currentPlayer = this
    this.player.playPause()

    if (this.player.isPlaying()) {
      this.playButtonTarget.innerHTML = PAUSE_ICON
    } else {
      this.playButtonTarget.innerHTML = PLAY_ICON
    }
  }

  format(seconds) {
    const m = Math.floor(seconds / 60)
    const s = Math.floor(seconds % 60)

    return `${m}:${s.toString().padStart(2, '0')}`
  }
}
